import React from 'react';

/**
 * ほんばん採点上限・プレミアム誘導ポップアップ
 * isPremium: プレミアムユーザーか（true=上限メッセージのみ、false=アップグレード案内）
 * onClose: 閉じる
 * onUpgrade: プレミアム誘導ボタン押下（将来Stripe画面へ）
 */
export default function PremiumPrompt({ isPremium, isGuest, onClose, onUpgrade }) {
  return (
    <div className="premium-prompt-overlay" onClick={onClose}>
      <div className="premium-prompt-sheet" onClick={(e) => e.stopPropagation()}>

        <div className="premium-prompt-icon">🎯</div>

        {isPremium ? (
          <>
            <div className="premium-prompt-title">今日のほんばん採点は終わり！</div>
            <div className="premium-prompt-body">
              プレミアムプランの1日10回を使い切りました。<br />
              また明日チャレンジしよう！
            </div>
            <button className="premium-prompt-close" onClick={onClose}>
              とじる
            </button>
          </>
        ) : isGuest ? (
          <>
            <div className="premium-prompt-title">ほんばん採点はここまで！</div>
            <div className="premium-prompt-body">
              おためしできるのは<strong>5回まで</strong>です。<br />
              ログインすると<strong>毎日</strong>ほんばん採点にちょうせんできるよ！
            </div>
            <button className="premium-prompt-upgrade" onClick={onUpgrade ?? onClose}>
              ログイン／とうろくする
            </button>
            <button className="premium-prompt-close" onClick={onClose}>
              今日はここまでにする
            </button>
          </>
        ) : (
          <>
            <div className="premium-prompt-title">今日のほんばん採点は終わり！</div>
            <div className="premium-prompt-body">
              無料プランは1日<strong>2回</strong>まで。<br />
              プレミアムにすると<strong>1日10回</strong>使えるよ！
            </div>
            <button className="premium-prompt-upgrade" onClick={onUpgrade ?? onClose}>
              👑 プレミアムにしよう（680円）
            </button>
            <button className="premium-prompt-close" onClick={onClose}>
              今日はここまでにする
            </button>
          </>
        )}

      </div>
    </div>
  );
}
